import React, { memo, useCallback } from 'react';
import { Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import DateRangePicker from '../../../../../../components/DateRangePicker/DateRangePicker';
import { ReactComponent as PeriodFilterIcon } from '../../../../../../resource/PeriodFilterIcon.svg';
import { filterConstants } from '../../../model/constants';
import SelectDateMode from '../../controls/SelectDateMode';
import { hasFilterValue, selectDateActiveCount } from '../../../model/activity';
import { useRequestFilterCommands } from '../../../model/commandsContext';
import { requestFilterSectionIds } from '../../../model/sectionExpansion';
import { useFilterChange } from '../../../model/useFilterChange';
import FilterField from '../../primitives/FilterField';
import FilterSection from '../../primitives/FilterSection';
import styles from './DateFilterSection.module.scss';

const DateFilterSection = () => {
  const filterCommands = useRequestFilterCommands();
  const dispatch = useDispatch();
  const dateRange = useSelector((state) => state.filterStore.dateRange);
  const selectedDateRange = useSelector(
    (state) => state.filterStore.selectedDateRange
  );
  const dateRangeField = useSelector(
    (state) => state.filterStore.dateRangeField
  );
  const activeCount = useSelector(selectDateActiveCount);
  const { markFilterChanged } = useFilterChange();

  const handleSelectDateRange = useCallback(
    (range) => {
      dispatch({
        type: filterConstants.SELECT_DATE_RANGE,
        payload: range,
      });
      markFilterChanged();
    },
    [dispatch, markFilterChanged]
  );

  const defineActiveRange = useCallback(
    ({ range }) => {
      const [currentFromDate, currentToDate] = dateRange;
      const [fromDate, toDate] = range;

      return (
        currentFromDate.isSame(fromDate, 'day') &&
        currentToDate.isSame(toDate, 'day')
      );
    },
    [dateRange]
  );

  return (
    <FilterSection
      sectionId={requestFilterSectionIds.date}
      heading="Период"
      description="Дата и режим фильтрации"
      icon={<PeriodFilterIcon />}
      activeCount={activeCount}
    >
      <div className={styles.content}>
        <FilterField
          label="Фильтровать по дате"
          active={hasFilterValue(dateRangeField)}
        >
          <SelectDateMode onChange={markFilterChanged} />
        </FilterField>

        <FilterField
          label="Диапазон дат"
          active={hasFilterValue(dateRange)}
        >
          <Form.Item>
            <DateRangePicker
              storedDatesRange={dateRange}
              storedSelectedRange={selectedDateRange}
              getDataByRangeAction={filterCommands.setDateRange}
              handleSelectedRange={handleSelectDateRange}
              defineActiveRange={defineActiveRange}
            />
          </Form.Item>
        </FilterField>
      </div>
    </FilterSection>
  );
};

export default memo(DateFilterSection);
